export default __webpack_public_path__ + "static/media/iconHomePaper.924cc30f.svg";